import { styled } from '../theme';
import Text from './Text';

const H4 = styled(Text.withComponent('h4'))(({ theme }) => ({
    fontWeight: theme.typography.fontWeight.medium,
    fontSize: '2.2rem',
}));

export default H4;
